module.exports = __webpack_public_path__ + "static/media/logo-success.445dded0.svg";